import { useEffect } from 'react';

type UseKeyDownHandlerProps = {
  open: boolean;
  resetSelection: () => void;
};

const useKeyDownHandler = ({
  open,
  resetSelection,
}: UseKeyDownHandlerProps) => {
  useEffect(() => {
    if (!open) return () => false;
    const keydownHandler = ({ key }: KeyboardEvent) => {
      if (key === 'Backspace') resetSelection();
    };
    document.addEventListener('keydown', keydownHandler);
    return () => document.removeEventListener('keydown', keydownHandler);
  }, [open, resetSelection]);
};

export default useKeyDownHandler;
